
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashion-internships",
      function () {
        return require("private-next-pages/fashion-internships.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashion-internships"])
      });
    }
  